"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tsParticles = exports.pJSDom = exports.particlesJS = exports.loadFull = exports.Main = exports.Utils = exports.Rectangle = exports.Point = exports.NumberUtils = exports.Constants = exports.ColorUtils = exports.CircleWarp = exports.Circle = exports.CanvasUtils = void 0;
const pjs_1 = require("./pjs");
const main_1 = require("./main");
Object.defineProperty(exports, "Main", { enumerable: true, get: function () { return main_1.Main; } });
const CanvasUtils = __importStar(require("./Utils/CanvasUtils"));
exports.CanvasUtils = CanvasUtils;
const ColorUtils = __importStar(require("./Utils/ColorUtils"));
exports.ColorUtils = ColorUtils;
const NumberUtils = __importStar(require("./Utils/NumberUtils"));
exports.NumberUtils = NumberUtils;
const Utils = __importStar(require("./Utils/Utils"));
exports.Utils = Utils;
const Utils_1 = require("./Utils");
Object.defineProperty(exports, "Circle", { enumerable: true, get: function () { return Utils_1.Circle; } });
Object.defineProperty(exports, "CircleWarp", { enumerable: true, get: function () { return Utils_1.CircleWarp; } });
Object.defineProperty(exports, "Constants", { enumerable: true, get: function () { return Utils_1.Constants; } });
Object.defineProperty(exports, "Point", { enumerable: true, get: function () { return Utils_1.Point; } });
Object.defineProperty(exports, "Rectangle", { enumerable: true, get: function () { return Utils_1.Rectangle; } });
const full_1 = require("./full");
Object.defineProperty(exports, "loadFull", { enumerable: true, get: function () { return full_1.loadFull; } });
const tsParticles = new main_1.Main();
exports.tsParticles = tsParticles;
tsParticles.init();
full_1.loadFull(tsParticles);
const { particlesJS, pJSDom } = pjs_1.initPjs(tsParticles);
exports.particlesJS = particlesJS;
exports.pJSDom = pJSDom;
__exportStar(require("./Core/Particle/Vector"), exports);
__exportStar(require("./Core/Container"), exports);
__exportStar(require("./Enums"), exports);
__exportStar(require("./Plugins/Absorbers/Enums"), exports);
__exportStar(require("./Plugins/Emitters/Enums"), exports);
__exportStar(require("./Plugins/PolygonMask/Enums"), exports);
__exportStar(require("./Types"), exports);
__exportStar(require("./Core/Interfaces"), exports);
__exportStar(require("./Core/Particle"), exports);
__exportStar(require("./Core/ExternalInteractorBase"), exports);
__exportStar(require("./Core/ParticlesInteractorBase"), exports);
